import { REDIS_QUICK } from '@/components/editor/snippets/quick/redis';
import { MYSQL_QUICK } from '@/components/editor/snippets/quick/mysql';

const quicks = {
  Redis: REDIS_QUICK,
  MySQL: MYSQL_QUICK
};

export const getQuick = (dsType) => quicks[dsType] || [];
